<template>
  <div class="overlay-cart-items">
    <CartItem :line="line" v-for="line in items" :key="line.id" />
  </div>
</template>

<script lang="ts" setup>
import { computed, unref } from 'vue'
import { useCartInject } from '../../../context/useCartContext'
import CartItem from '../../cart/CartItem.vue'

const { cart } = useCartInject()

const items = computed(() => {
  return (unref(cart)?.items || []).filter((item) => !item.properties.Product)
})
</script>

<style lang="scss">
.overlay-cart-items {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  padding: 10px;
}
</style>
